import { useEffect, useState } from "react";
import { AdminPickCounts } from "fragments/admin/AdminPickCounts";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import { TabPanel } from "../components/TabPanel";
import "./Admin.scss";
import { useNavigate, useParams } from "react-router-dom";
import { AdminCurrentRound } from "fragments/admin/AdminCurrentRound";
import { AdminTeams } from "fragments/admin/AdminTeams";
import { AdminNextRound } from "fragments/admin/AdminNextRound";
import { AdminPoints } from "fragments/admin/AdminPoints";
import { AdminImpersonate } from "fragments/admin/AdminImpersonate";
import { AdminInfo } from "fragments/admin/AdminInfo";

export const Admin = () => {
  const urlParams = useParams();
  const navigate = useNavigate();

  const [currentTabIndex, setCurrentTabIndex] = useState<number>(-1);

  const tabs = [
    { label: "Pick Counts", index: 0, name: "pick-counts" },
    { label: "Current Round", index: 1, name: "current-round" },
    { label: "Next Round", index: 2, name: "next-round" },
    { label: "Teams", index: 3, name: "teams" },
    { label: "Points", index: 4, name: "points" },
    { label: "Impersonate", index: 5, name: "impersonate" },
    { label: "Info", index: 6, name: "info" },
  ];

  useEffect(() => {
    document.title = "Playoff Bracket Pool: Admin";
  }, []);

  useEffect(() => {
    if(!urlParams.tabName) 
      navigate(`/admin/${tabs[0].name}`);
    const tab = tabs.find((c) => urlParams.tabName?.toLocaleLowerCase() === c.name);
    if (tab) setCurrentTabIndex(tab.index);
  }, [urlParams.tabName, navigate]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const tab = tabs.find((c) => c.index === newValue);
    if (tab) navigate(`/admin/${tab.name}`);
    //setCurrentTabIndex(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  return (
    <div className="admin-root">
      <div>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {currentTabIndex >= 0 ? (
            <Tabs value={currentTabIndex} onChange={handleTabChange} aria-label="basic tabs example">
              {tabs.map((tab) => (
                <Tab key={tab.name} label={tab.label} {...a11yProps(tab.index)} />
              ))}
            </Tabs>
          ) : (
            <div></div>
          )}
        </Box>
        <TabPanel value={currentTabIndex} index={0} className="tab-panel">
          <AdminPickCounts />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={1} className="tab-panel">
          <AdminCurrentRound />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={2} className="tab-panel">
          <AdminNextRound />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={3} className="tab-panel">
          <AdminTeams />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={4} className="tab-panel">
          <AdminPoints />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={5} className="tab-panel">
          <AdminImpersonate />
        </TabPanel>
        <TabPanel value={currentTabIndex} index={6} className="tab-panel">
          <AdminInfo />
        </TabPanel>
      </div>
    </div>
  );
};
